import { StreamStatusLunaStreams } from '@vlabs/monokit/shared/ui/stream-statuses';
import i18n from 'i18next';

import type { TLunaStreamGroup, TLunaStream, TUiStreamGroup } from '../types';

interface UiLunaStreamsGroupsProps {
  groups: TLunaStreamGroup[];
  streams: TLunaStream[];
}

export function buildUiLunaStreamsGroups({
  groups = [], streams = [],
}: UiLunaStreamsGroupsProps): TUiStreamGroup[] {
  const ungrouped = [] as TLunaStream[];
  const streamsByGroupName = new Map();

  streams.forEach((stream) => {
    const groupList = Array.isArray(stream.groupsRaw) ? stream.groupsRaw : [];

    if (groupList.length === 0) {
      ungrouped.push(stream);
      return;
    }

    groupList.forEach((groupName) => {
      const groupStreams = streamsByGroupName.get(groupName);

      if (groupStreams) {
        groupStreams.push(stream);
      } else {
        streamsByGroupName.set(groupName, [stream]);
      }
    });
  });

  const uiGroups = groups.map((g) => {
    const groupStreams = streamsByGroupName.get(g.group_name) ?? [];

    return {
      id: g.group_id,
      label: g.group_name,
      defaultCollapsed: false,
      items: groupStreams.map((s) => ({
        id: s.stream_id,
        value: s.name,
        label: s.name,
        rightSlot: <StreamStatusLunaStreams
          status={s.statusRaw}
          type="badge"
        />,
      })),
    };
  });

  uiGroups.push({
    id: '__ungrouped__',
    label: i18n.t('sources.ungrouped sources title'),
    defaultCollapsed: false,
    items: ungrouped.map((s) => ({
      id: s.stream_id,
      value: s.name,
      label: s.name,
      rightSlot: <StreamStatusLunaStreams
        status={s.statusRaw}
        type="badge"
      />,
    })),
  });

  return uiGroups.filter((g) => g.items.length > 0);
}
